type RegistrationDraft = Readonly<{email: string; password: string; termsAccepted: boolean}>;

const emptyDraft: RegistrationDraft = {email: '', password: '', termsAccepted: false};
// One tab-local draft survives registration page and dialog unmounts. Never serialize credentials.
let draft = emptyDraft;
const listeners = new Set<() => void>();

export function registrationDraftSnapshot(): RegistrationDraft {return draft;}
export function subscribeRegistrationDraft(listener: () => void): () => void {
  listeners.add(listener);
  return () => {listeners.delete(listener);};
}
export function updateRegistrationDraft(patch: Partial<RegistrationDraft>): void {
  const next = {...draft, ...patch};
  if (next.email === draft.email && next.password === draft.password && next.termsAccepted === draft.termsAccepted) return;
  draft = next;
  for (const listener of listeners) listener();
}
export function hasRegistrationDraft(): boolean {
  return Boolean(draft.email || draft.password || draft.termsAccepted);
}
export function clearRegistrationDraft(): void {
  if (!hasRegistrationDraft()) return;
  draft = emptyDraft;
  for (const listener of listeners) listener();
}
